/** Entry point of the kaohsiung package (Kaohsiung). Imported once from main.ts. */
import '../render/propsHlcity';
import '../render/propsXinyi';
import '../render/propsCks';
import '../render/propsKaohsiung';
import './kaohsiung';
import { registerNpcs } from '../world/npcs';
import { NPCS_KAOHSIUNG } from '../world/npcsKaohsiung';

registerNpcs(NPCS_KAOHSIUNG);
